import BaseModel from './BaseModel'
import AuthService from '../service/auth-service';
import RegionService from '../service/region-service';
import Membership from './Membership';
import moment from 'moment';

const Months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export default class User extends BaseModel {

    constructor(data = {}) {
        let date = data.DateOfBirth ? new Date(parseInt(data.DateOfBirth)) : undefined;
        super();
        this.MemberId = data.MemberId;
        this.FirstName = data.FirstName;
        this.LastName = data.LastName;
        this.CardNumber = data.CardNumber;
        this.MobilePhone = data.MobilePhone;
        this.HomePhone = data.HomePhone || false;
        this.Email = data.Email;
        this.ClubID = data.ClubID;
        this.CardList = data.CardList || [];
        this.MembershipActivated = Boolean(data.MembershipActivated);
        this.ExpiryPointsList = data.ExpiryPointsList || [];
        this.MemberLevelId = data.MemberLevelId || 19;
        this.BalanceList = data.BalanceList || [];
        this.SendNewsletter = Boolean(data.SendNewsletter);
        this._DobYear = date ? date.getFullYear() : undefined;
        this._DobMonth = date ? Months[date.getMonth()] : undefined;
        this._DobDay = date ? date.getDate() : undefined;
        this.CreatedDate = data.ExpiryDate ? moment.unix(parseInt(data.ExpiryDate) / 1000).subtract(100, 'years') : null;
        this.PreferredComplexList = data.PreferredComplexList || [];
        this.PreferenceList = data.PreferenceList || [];
        this.PreferredGenres = data.PreferredGenres || [];
        this.PreferredComplex = undefined;
        this.PersonsInHousehold = data.PersonsInHousehold || 1;
        this.Gender = data.Gender || undefined;
        this.NationalID = data.NationalID || undefined;
        this.StandardBankBenefit = data.StandardBankBenefit || false;
        this.UserSessionId = data.UserSessionId;
        this.WorkZipCode = data.WorkZipCode || undefined;
        this.ZipCode = data.ZipCode || "False";

        if (data.PreferredComplex) {
            this.PreferredComplex = {};
            RegionService.getRegions().then((regions)=> {
                for (var r = 0; r < regions.data.length; r++) {
                    for (var c = 0; c < regions.data[r].cinemas.length; c++) {

                        if (data.PreferredComplex == regions.data[r].cinemas[c].loyalty_cinema_id) {
                            this.PreferredComplex = regions.data[r].cinemas[c]
                        }
                    }

                }
            })
        }


    }

    setActivated(activated) {
        this.MembershipActivated = Boolean(activated);
        AuthService.notifyObservers(AuthService.PROFILE_CHANGED);
    }

    /**
     * @return {Moment | undefined}
     */
    get DateOfBirth() {
        var hasDob = this._DobYear && this._DobMonth != undefined && this._DobDay;
        let month = hasDob ? Months.indexOf(this._DobMonth) : null;
        return hasDob ? new Date(this._DobYear, month, this._DobDay, 0, 0, 0, 0) : undefined;
    }

    /**
     * @return {string | undefined}
     */
    get FullName() {
        return this.FirstName ? this.FirstName + (this.LastName ? (' ' + this.LastName) : undefined) : undefined;
    }

    get PointsBalance() {
        return this.BalanceList.reduce((val, balObj)=>val += balObj.PointsRemaining, 0) || 0;
    }

    get LifeTimePoints() {
        return this.BalanceList.reduce((val, balObj)=>val += balObj.LifetimePointsBalanceDisplay, 0) || 0;
    }

    get isGuestUser() {
        return this.isGuest();
    }

    isVip() {
        return this.MemberLevelId === 2;
    }

    isGuest() {
        return !this.MemberId;
    }

    addCard(CardNumber, Type) {
        if (!~this.CardList.findIndex((m)=>m.CardNumber == CardNumber)) {
            this.CardList = [];
            this.CardList.push(new Membership({CardNumber, Type}));
        }
        return this.CardList
    }

    save() {
        return (this.MemberId ? AuthService.updateUser(this) : AuthService.signUp(this)).then((user)=> {
            if (user) {
                Object.assign(this, user);
            }
            return this;
        });
    }

    saveCards() {
        return new Promise((resolver, rejector)=> {
            if (this.MemberId)
                AuthService.updateUserCards({CardList: this.CardList}).then((response)=> {
                    resolver(response);
                    // if (response.success === true) {
                    //     Object.assign(this, response.data);
                    // }
                    // return this;
                },(er)=>rejector(er));
            else {
                rejector('attempting to modify an anonymous user!')
            }
        })
    }

    _cardListAsStringArray() {
        return this.CardList.map((item)=>JSON.stringify(item));
    }

    toJSON() {
        return {
            FirstName: this.FirstName,
            LastName: this.LastName,
            Email: this.Email,
            Password: this.Password || undefined,
            MobilePhone: this.MobilePhone,
            DateOfBirth: this.DateOfBirth,
            Memberships: this.Memberships,
            SendNewsletter: this.SendNewsletter,
            PreferenceList: this.PreferenceList,
            PreferredGenres: this.PreferredGenres,
            PreferredComplexList: this.PreferredComplexList,
            PreferredComplex: this.PreferredComplex,
            PersonsInHousehold: this.PersonsInHousehold,
            Gender: this.Gender,
            NationalID: this.NationalID,
            MemberLevelId: this.MemberLevelId,
            CardNumber: this.CardNumber,
            _DobMonth: this._DobMonth,
            _DobDay: this._DobDay,
            _DobYear: this._DobYear,
            StandardBankBenefit: this.StandardBankBenefit,
            UserSessionId: this.UserSessionId,
            WorkZipCode: this.WorkZipCode,
            ZipCode: this.ZipCode,
        };
    }
}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/User.js